export const payload = {
  receiveMutation: 'RECEIVE_ADDRESSES',
  receivingMutation: 'RECEIVING_ADDRESSES',
  receiveMetadataMutation: 'RECEIVE_ADDRESS_METADATA',
  receiveFailureMutation: 'RECEIVE_ADDRESS_FAILURE',
  savingMutation: 'SAVING_ADDRESS',
  saveFailureMutation: 'SAVING_ADDRESS_FAILURE',
  incrementMutation: 'INCREMENT_ADDRESS_COUNT',
  updatingMutation: 'UPDATING_ADDRESS',
  updateFailureMutation: 'UPDATING_ADDRESS_FAILURE',
  deleteMutation: 'DELETE_ADDRESS',
  deletingMutation: 'DELETING_ADDRESS',
  deleteFailureMutation: 'DELETING_ADDRESS_FAILURE',
  resetMetaMutation: 'RESET_ADDRESS_META',
  clearMutation: 'CLEAR_ADDRESS_STATE',
  moduleName: 'address',
  endpoint: 'addresses'
}



// WEBPACK FOOTER //
// ./src/components/RouteComponents/Addresses/actionPayload.js